import React, { Component } from 'react';

// Components
import LegalDocumentLayout from '../LegalDocumentLayout';

// Data
import docData from './data';

class FAQ extends Component {
  render() {
    return (
      <LegalDocumentLayout
        docTitle="Frequently Asked Questions"
        docData={docData}
        numbered
      />
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/pages/LegalDocuments/FAQ/FAQ.js